import { put, call, all } from 'redux-saga/effects';
import * as APIs from 'services/api';
import { logout } from 'redux/actions/auth';
import { updateApp } from 'redux/actions/app';

export function* refreshApp() {
  try {
    const [response, maintenanceResponse] = yield all([
      call(APIs.getProfile),
      call(APIs.getMaintenance),
    ]);
    if (response.code === 200) {
      const maintenance = Array.isArray(maintenanceResponse?.data) && maintenanceResponse.data.length > 0
        ? maintenanceResponse.data[0]
        : null;
      yield put(
        updateApp({
          profile: { ...response.user, apiToken: response.apiToken },
          refreshed: true,
          maintenance,
        }),
      );
    } else {
      yield put(logout());
    }
  } catch (error) {
    console.log("refresh app error:", error);
    yield put(logout());
  }
}
